import { BUSINESS_LAYER_RESPONSE, EXCHANGE_NAME_LIVEPULSE, MULTIPLIER } from "../../utils/global_variables";
import { livePulse } from "../../apis/nontransactional";
import { convertToDate, getApiExchangeNameFromMktSegId, getDynamicParamsForToFixed, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view :added keys for expand view ---Start

async function
    _getLivePulse(objPayload) {

    try {

        let resp = await livePulse(objPayload);
        // Vinit Raut : 20-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start 
        //This function will display the company details in live pulse card and live pulse expanded view
        //objPayload contains market segment id number
        if (resp?.data?.result?.length > 0) {
            const livePulseData = resp?.data?.result?.map((ele) => {
                const obj = {};
                const strExchangeSegment = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(ele?.nMarketSegmentId));
                obj['companyName'] = ele?.sSymbol;
                obj['expiryMonth'] = ele?.nExpiryMonth;
                // Vinit Raut : 22-02-2024 : BT-108797 -  Breeze - Live pulse expanded view -- Start
                obj['expiry'] = convertToDate(ele?.nExpiryDate, "DD MMM")?.toLocaleUpperCase();
                // Vinit Raut : 22-02-2024 : BT-108797 -  Breeze - Live pulse expanded view -- End
                obj['sSupport'] = ele?.sDataDesc;
                obj['date'] = convertToDate(ele?.nData, "DD MMM'YY")?.toLocaleUpperCase();
                obj['time'] = convertToDate(ele?.nTimeStamp, "HH:MM:ss A");
                // Vinit Raut : 13-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- Start
                obj['price'] = parseFloat(ele?.nLTP).toFixed(2);
                obj['nPercChange'] = parseFloat(ele?.nPercChange).toFixed(2);
                // Vinit Raut : 13-12-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End
                obj['ltpClass'] = ele?.ltpClass;
                obj['nMarketSegmentId'] = ele?.nMarketSegmentId;
                obj['nToken'] = ele?.nToken;
                obj['sSeries'] = ele?.sSeries;
                obj['instrument'] = ele?.sInstrumentName;
                obj['sOptionType'] = ele?.sOptionType;
                obj['nStrikePrice'] = ele?.nStrikePrice;
                obj['decimalLocatorLength'] = getDynamicParamsForToFixed(strExchangeSegment);

                const number = (parseFloat(obj?.price) * parseFloat(obj?.nPercChange)) / MULTIPLIER?.HUNDRED;
                const nLtpChange = parseFloat(number)?.toFixed(obj?.decimalLocatorLength);
                obj['nLtpChange'] = nLtpChange;
                obj['strExchangeSegment'] = strExchangeSegment;//Azeem K :17-05-2024 : livePulse Regression Bug fixing : strExchangeSegment added

                return obj;
            });

            return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: livePulseData };

        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, data: null };
        }
        // Vinit Raut : 20-11-2023 : BT-108797 -  Breeze - Live pulse expanded view -- End

    } catch (error) {
        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }
};
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view :added keys for expand view ---End


const getTabs = (data = []) => {
    let tabs = [
        { name: "EQUITY", id: "EQ", exchanges: [] },
        { name: "DERIVATIVE", id: "FO", exchanges: [] },
        { name: "COMMODITY", id: "COMM", exchanges: [] },
        { name: "CURRENCY", id: "CUR", exchanges: [] }
    ];

    function getIndex(name, el) {
        let index = tabs?.findIndex(nm => nm.name === name);
        tabs[index]?.exchanges?.push({ exchName: EXCHANGE_NAME_LIVEPULSE[el], mktSgmtId: getMappedMktSegIdFromApiExchangeName(el) });
    }

    data?.forEach(el => {
        if (el === "NSE_EQ" || el === "BSE_EQ" || el === 'MSE_EQ') {
            getIndex('EQUITY', el);
        }
        if (el === "BSE_COMM" || el === "NSE_COMM" || el === "MCX_FO" || el === "NCDEX_FO" || el === "ICEX_FO") {
            getIndex("COMMODITY", el);
        }
        if (el === "NSE_CUR" || el === "BSE_CUR") {
            getIndex("CURRENCY", el);
        }
        if (el === "NSE_FO" || el === "BSE_FO") {
            getIndex("DERIVATIVE", el);
        }
    });
    return tabs.filter(x => x.exchanges.length);
};



export { _getLivePulse, getTabs };
